import { render } from "./AuthContainer.vue?vue&type=template&id=644100ea&scoped=true&ts=true"
import script from "./AuthContainer.vue?vue&type=script&lang=ts"
export * from "./AuthContainer.vue?vue&type=script&lang=ts"

import "./AuthContainer.vue?vue&type=style&index=0&id=644100ea&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644100ea"]])

export default __exports__